import { SVGProps } from "react";

const Medal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 12.5001C13.1066 12.5001 15.625 10.075 15.625 7.08342C15.625 4.09187 13.1066 1.66675 10 1.66675C6.8934 1.66675 4.375 4.09187 4.375 7.08342C4.375 10.075 6.8934 12.5001 10 12.5001Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.27003 11.2667L6.26172 17.4167C6.26172 18.1667 6.78672 18.5334 7.43672 18.225L9.67005 17.1667C9.85338 17.075 10.1617 17.075 10.345 17.1667L12.5867 18.225C13.2284 18.525 13.7617 18.1667 13.7617 17.4167V11.1167"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.3609 5.29872L10.7283 6.04155C10.7769 6.14666 10.9086 6.24477 11.0196 6.25879L11.6852 6.37091C12.1081 6.44099 12.2121 6.75633 11.9071 7.05766L11.387 7.58325C11.2969 7.67435 11.2484 7.84254 11.2761 7.96168L11.4217 8.6064C11.5396 9.11797 11.2692 9.31419 10.8254 9.0479L10.2014 8.67649C10.0905 8.60641 9.90325 8.60641 9.79231 8.67649L9.16828 9.0479C8.72453 9.31419 8.45412 9.11797 8.57199 8.6064L8.7176 7.96168C8.74534 7.84254 8.6968 7.66734 8.60667 7.58325L8.09358 7.06468C7.7885 6.75634 7.88557 6.44798 8.31545 6.37791L8.98108 6.2658C9.09202 6.24478 9.22375 6.14667 9.27229 6.04856L9.63977 5.30571C9.84084 4.89926 10.1598 4.89928 10.3609 5.29872Z"
      fill="currentColor"
    />
  </svg>
);
export default Medal;
